<div class="modal-wrapper">
  <div class="modal-header">
    <h4
      class="modal-title"
      id="modal-basic-title"
      i18n="@@admin.panel.deleteversion"
    >
      Delete version {{ template.version }}
    </h4>
    <i
    class="fas fa-times clickable"
    (click)="activeModal.dismiss('Cross click')"
  ></i>
  </div>
  <div class="modal-body" i18n="@@admin.panel.deleteversion.areyousure">
    <p>Are you sure want to delete this version</p>
  </div>
  <div class="modal-footer">
    <button
      class="quit-button"
      (click)="onNo()"
      i18n="@@admin.panel.deleteversion.cancel"
    >
      Cancel
    </button>
    <button class="save-button" (click)="onYes()">
      <img src="assets/Keen&Wise_delete_round_transparant.png" />
      <span i18n="@@admin.panel.deleteversion.yesno">Yes, delete</span>
    </button>
  </div>
</div>
